module.exports = __webpack_public_path__ + "e1cbb56ed143a32b96bcb0dccbcce4b2.MP3";